import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { MentorFormDataService } from "common/services/data-services/admin/mentor/mentor-form-data.service";
import { stateListDataService } from "common/services/data-services/custom-service/stateList-service.service";
import { CompanyGridDataService } from "common/services/data-services/admin/internship-company/company-grid-data.service";
import { MentorModel } from "common/models/page-models/mentor/mentor-data-model";
import { MentorMetaModel } from "common/models/page-models/mentor/mentors-meta-model";
import { MentorMappingListDataService } from "common/services/data-services/custom-service/mentor-list-service";
import { ChangeMentorMetaModel } from "common/models/page-models/mentor/change-mentor-meta-model";
import { ChangeMentorFormDataService } from "common/services/data-services/admin/mentor/change-mentor-form-data.service";
import { ChangeMentorModel } from "common/models/page-models/mentor/change-mentor-model";

@Injectable({
    providedIn: 'root'
})

export class  ChangeMentorFormWidgetService extends FormWidgetService<ChangeMentorModel> {
    constructor(protected ds: ChangeMentorFormDataService, private stateService: stateListDataService, private internshipCompanyService: CompanyGridDataService, private mentorListService: MentorMappingListDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new ChangeMentorMetaModel();
        return meta.getMetaModel();
    }

  
    override prepareMetaModel(dataModel: DataModel, metaModel: MentorMetaModel, routeData: WidgetModel): Promise<MentorMetaModel> {
        return new Promise<MentorMetaModel>((resolve, reject) => {
            metaModel.pageTitle = 'Update Mentor';
            this.mentorListService.postData('').then((data) => {
                metaModel.properties['mentorId'].options = data.details;
            });
            resolve(metaModel);
        });
    }
}
